import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/outline';
import { faqs } from '../../../utils/FAQData';
import ContactButton from '../../MainComponents/ContactButton';
import withAnimation from '../../../hooks/withAnimation';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-lightBackground py-16">
      <section className="w-full flex flex-col items-center justify-around self-center   px-6 lg:px-12 lg:flex-row">
        {/* Section Heading */}
        <div>
        <h2 className="text-3xl lg:text-5xl w-[75%] font-bold text-primary text-start mb-10">
          Frequently Asked <span className='mt-18 '>Questions</span>
        </h2>
        <p className='text-lg text-gray-500'>Reach out if you can’t find what you’re looking for.</p>
        <ContactButton bookOnlineText='Contact Us' callButtonStyle='hidden' bookOnlinestyle='bg-orange text-white p-5 rounded-full' mainContStyle='mt-8 flex flex-col justify-start sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-4'/>
        </div>
        
        {/* FAQ Items */}
        <div className="space-y-5 mt-10 lg:mt-0">
          {faqs.map((faq, index) => (
            <div key={index} className="border border-gray-200 rounded-lg shadow-lg overflow-hidden">
              <button
                className="w-full flex justify-between items-center px-6 py-4 bg-white text-left focus:outline-none hover:bg-gray-100 transition-all duration-200"
                onClick={() => toggleFAQ(index)}
              >
                <span className="text-lg sm:text-xl font-semibold text-primary">{faq.question}</span>
                {openIndex === index ? (
                  <ChevronUpIcon className="h-6 w-6 text-primary" />
                ) : (
                  <ChevronDownIcon className="h-6 w-6 text-primary" />
                )}
              </button>
              {/* Answer Section */}
              {openIndex === index && (
                <div className="w-full px-6 py-4 bg-gray-50 transition duration-300 ease-in-out">
                  <p className="text-base sm:text-lg text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default withAnimation(FAQSection);
